@let ratings = filteredRatings(filterValue, $ratingsToRender());
@let ratingsStatus = $ratingsStatus();
@let checkedRatings = $checkedRatings();
@let isInsideDealDetails = $isInsideDealDetails();
@let isInsideSummary = $isInsideSummary();
@let isLoading = !!(isLoading$ | async);

<style>
  /* v5: --tui-padding больше не используется, а текст кнопки по умолчанию не переносится */
  [tuiButton][data-appearance='flat'] {
    padding-inline: 1rem;
    margin-left: -1rem;
    width: calc(100% + 2rem);
    white-space: normal;
  }
  hr {
    border-bottom: 1px solid var(--x-color-gray);
    margin-left: -1rem;
    width: calc(100% + 2rem);
  }
</style>

@if (!isInsideSummary) {
  <div
    class="x-card x-card_size_m x-white card-shadow m-auto pb-0! pt-0! flow-root!"
    [tuiSkeleton]="!!(isLoading$ | async) && $isInitialLoad()"
    [ngClass]="{
      'md:w-2/3': !$groupActionMode() && !isInsideDealDetails,
      'mt-2': isInsideDealDetails,
      'my-4.5': !isInsideDealDetails,
    }"
  >
    @if (isInsideDealDetails) {
      <h3 class="font-bold text-[1.1875rem]/7 m-0 pt-4">
        {{ 'request_form.ratings.inside_deal_details_title' | translate }}
      </h3>
    }

    @if ($canEditRequestRatings()) {
      <tui-textfield
        iconStart="@tui.search"
        class="my-4 rounded-3xl! x-textfield-on-light"
        [tuiTextfieldCleaner]="true"
      >
        <input
          placeholder="{{ 'request_form.ratings.search' | translate }}"
          tuiInput
          [(ngModel)]="filterValue"
          [disabled]="$ratingsToRender().length === 0"
        />
      </tui-textfield>
      @if (ratings.length) {
        <hr />
      }
    }
    @for (rating of ratings; track rating.id; let idx = $index) {
      @if (isInsideDealDetails) {
        @if (ratingsStatus[rating.id] || idx <= 4) {
          @if (
            ratings.length > 0 &&
            idx === 0 &&
            !filterValue &&
            isInsideDealDetails &&
            ratingsExpanded
          ) {
            <button
              tuiButton
              appearance="flat"
              type="button"
              class="w-full p-0 rounded-none!"
              [disabled]="!$canEditRequestRatings() || isLoading"
              (click)="ratingsExpanded = !ratingsExpanded"
              iconEnd="@tui.chevron-up"
            >
              {{ 'request_form.ratings.collapse' | translate }}
            </button>
            <hr />
          }
          <ng-container
            [ngTemplateOutlet]="ratingButtonTemplate"
            [ngTemplateOutletContext]="{
              rating,
            }"
          />
        } @else {
          <tui-expand [expanded]="ratingsExpanded"
            ><ng-container
              [ngTemplateOutlet]="ratingButtonTemplate"
              [ngTemplateOutletContext]="{
                rating,
              }"
          /></tui-expand>
        }
      } @else {
        <ng-container
          [ngTemplateOutlet]="ratingButtonTemplate"
          [ngTemplateOutletContext]="{
            rating,
          }"
        />
      }
    } @empty {
      <div class="text-center py-4 w-full typo-body-l x-text-01 font-medium">
        {{ 'request_form.ratings.ratings_not_found' | translate }}
      </div>
    }
    @if (ratings.length > 0 && !filterValue && isInsideDealDetails) {
      <button
        tuiButton
        type="button"
        (click)="ratingsExpanded = !ratingsExpanded"
        appearance="flat"
        class="w-full p-0 rounded-t-none!"
        [iconEnd]="ratingsExpanded ? '@tui.chevron-up' : '@tui.chevron-down'"
      >
        {{
          ratingsExpanded
            ? ('request_form.ratings.collapse' | translate)
            : ('request_form.ratings.expand' | translate)
        }}
      </button>
    }
  </div>
} @else {
  @for (
    checkedRating of checkedRatings;
    track checkedRating.id;
    let idx = $index
  ) {
    @if (idx < 8) {
      <span
        tuiBadge
        class="checked-summary-rating-badge me-2 mb-1"
        [ngStyle]="{
          'border-color':
            checkedRating.color === '#ffffff'
              ? 'var(--x-dark-secondary)'
              : checkedRating.color,
        }"
        ><div
          class="w-[10px] h-[10px] rounded-[50%] me-2"
          [ngStyle]="{
            'background-color':
              checkedRating.color === '#ffffff'
                ? 'var(--x-dark-secondary)'
                : checkedRating.color,
          }"
        ></div>
        {{ checkedRating | entityTranslate: 'request_ratings' }}</span
      >
    }
  } @empty {
    <p class="x-font-body-2-bold x-text-dark-secondary">
      {{ 'request_form.ratings.no_ratings' | translate }}
    </p>
  }
  @let count = checkedRatings.length;
  @if (count > 8) {
    <span
      tuiBadge
      class="mx-1 font-medium! mb-1 cursor-pointer"
      size="l"
      (click)="openModal()"
      >{{ '+' + (count - 8) }}</span
    >
  }
}

<ng-template #ratingButtonTemplate let-rating="rating">
  <button
    tuiButton
    appearance="flat"
    type="button"
    class="w-full first:pt-0 h-auto! rounded-none!"
    [disabled]="!$canEditRequestRatings() || isLoading"
    (click)="handleButtonClick(rating)"
  >
    <div class="flex items-center justify-between py-4 w-full">
      <div class="text-left">
        <span
          class="inline-block w-4 h-4 rounded-full align-middle mr-2"
          [style.background-color]="rating.color"
        ></span>
        <span class="typo-ui-m x-text-01 text-left font-medium pr-2">{{
          rating | entityTranslate: 'request_ratings'
        }}</span>
      </div>
      <input
        tuiCheckbox
        type="checkbox"
        size="m"
        class="shrink-0"
        [disabled]="!$canEditRequestRatings()"
        [(ngModel)]="ratingsStatus[rating.id]"
        (ngModelChange)="toggleRating$.next(rating)"
      />
    </div>
  </button>
  <hr [ngClass]="{ 'last:hidden': !isInsideDealDetails }" />
</ng-template>
